import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { apiUri, filterRequest } from "../../utilities/apiManager";
import axios from "axios";

let initialState = {
  isLoading: false,
  data: [],
  itemsCount: 0,
  pages: 0,
  error: null,
}

export const getInstallmentsInvoices = createAsyncThunk(
  "installments/getInstallmentsInvoices",
  async (args, thunkApi) => {
    try {
      const { page, size = 10, query } = args;
      const filter = filterRequest(args.filter);
      const { data } = await axios.get(
        `${apiUri}/installments_invoices?page=${page}&size=${size}&query=${query}${filter}`,
        {
          headers: {
            'Content-Type': 'application/json',
            "Accept-Language": document.documentElement.lang,
            "auth-token": "Bearer " + thunkApi.getState().auth.accessToken
          }
        }
      );
      return thunkApi.fulfillWithValue(data);
    } catch (errors) {
      console.log(errors);
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

const installmentsInvoicesSlice = createSlice({
  name: "installments",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getInstallmentsInvoices.pending, (state) => {
        state.isLoading = true;
        state.error = null
      })
      .addCase(getInstallmentsInvoices.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.error = null;
        // Handle both possible API response structures
        state.data = payload.data?.data || payload.data || [];
        state.itemsCount = payload.data?.itemsCount || payload.itemsCount || 0;
        state.pages = payload.data?.pages || payload.pages || 0;
      })
      .addCase(getInstallmentsInvoices.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      })
  }
});

export default installmentsInvoicesSlice.reducer;